import { z } from "zod";

export const NutrientAmountSchema = z.record(z.string(), z.string());
